import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';

export default function ExpandablePanel({
  title,
  children,
  fixedHeight = 420,
  headerActions,
  compactHeight,
  showClear = false,
  onClear,
  clearLabel = 'Clear Filter',
}) {
  const [expanded, setExpanded] = useState(false);
  const height = compactHeight || fixedHeight;

  return (
    <>
      <div className="cs-panel" style={{ height: `${height}px` }}>
        <div className="cs-panel__header">
          <div className="cs-panel__title-row">
            <h6 className="cs-panel__title mb-0">{title}</h6>
          </div>
          <div className="cs-panel__toolbar-row">
            {showClear && onClear && (
              <button type="button" className="cs-chip-clear" onClick={onClear}>
                {clearLabel}
              </button>
            )}
            <div className="cs-panel__actions">
              {headerActions}
              <button
                type="button"
                className="btn btn-sm cs-panel__expand-btn"
                onClick={() => setExpanded(true)}
                title="Expand"
              >
                <FontAwesomeIcon icon={faExpand} />
              </button>
            </div>
          </div>
        </div>
        <div className="cs-panel__body custom-scrollbar">
          {children}
        </div>
      </div>

      <Modal
        show={expanded}
        onHide={() => setExpanded(false)}
        dialogClassName="cs-panel-modal"
        size="xl"
        centered
        scrollable
      >
        <Modal.Header className="cs-panel-modal__header" closeButton>
          <div className="cs-panel-modal__header-content">
            <div className="cs-panel__title-row">
              <Modal.Title className="cs-panel-modal__title">
                <h6 className="cs-panel__title mb-0">{title}</h6>
              </Modal.Title>
            </div>
            <div className="cs-panel__toolbar-row">
              <div className="cs-panel__actions">
                {headerActions}
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="cs-panel-modal__body custom-scrollbar p-0">
          {children}
        </Modal.Body>
        <Modal.Footer className="cs-panel-modal__footer py-1 px-3">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setExpanded(false)}
          >
            <FontAwesomeIcon icon={faCompress} className="me-1" />
            Collapse
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
